import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { IUserPresence } from 'types/UserPresence';
import { IUser } from 'types/User';

// Define a type for the slice state
interface UserState {
  user: IUser | null;
  infoUser: {
    numberPhone: string;
    access_token: string;
  } | null;
  token: string;
  activeUser: IUserPresence[];
  onlineCount: number;
}

// Define the initial state using that type
const initialState: UserState = {
  user: null,
  infoUser: null,
  token: '',
  activeUser: [],
  onlineCount: 0,
};

export const userSlice = createSlice({
  name: 'user',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload;
    },

    setUpdateUser: (state, action: PayloadAction<Partial<IUser>>) => {
      if (state.user) state.user = { ...state.user, ...action.payload };
    },

    setInfoUser: (
      state,
      action: PayloadAction<{
        numberPhone: string;
        access_token: string;
      }>,
    ) => {
      state.infoUser = action.payload;
    },

    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },

    setActiveUser: (state, action: PayloadAction<IUserPresence[]>) => {
      state.activeUser = action.payload;
    },

    setOnlineCount: (state, action: PayloadAction<number>) => {
      state.onlineCount = Number.isFinite(action.payload) ? action.payload : 0;
    },
  },
});

export const {
  setUser,
  setUpdateUser,
  setInfoUser,
  setToken,
  setActiveUser,
  setOnlineCount,
} = userSlice.actions;

export default userSlice.reducer;
